// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:960px){.landing__section[data-v-fe2a6510]:not(:last-child){margin-bottom:24px}}.gradient-background[data-v-fe2a6510]{background:#fff;background:linear-gradient(0deg,#fff,#fff 95%,#f0f9ff)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
